import { createContext, useContext } from 'react';
import type { SnapshotService } from './snapshot-service';

export const SnapshotServiceContext = createContext<SnapshotService | null>(null);

export function useSnapshotService(): SnapshotService {
  const svc = useContext(SnapshotServiceContext);
  if (!svc) throw new Error('useSnapshotService must be used inside SnapshotServiceProvider');
  return svc;
}
